// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { xLayer as _xLayer } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the xLayer chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 196
 * Chain Name: X Layer Mainnet
 * Default Block Explorer: https://www.oklink.com/xlayer
 * Default RPC URL: https://rpc.xlayer.tech
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { xLayer } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: xLayer,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const xLayer = createCommon({
	..._xLayer,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
